<template>
	<div class="newReview">
		<el-dialog
			:visible.sync="dialogVisible" :before-close="handleCloseNewReview" :close-on-click-modal="false" :append-to-body="false">
			<p class="title pl14">
				<i class="iconfont icon-xinjian mr8"></i>
				退回意见
			</p>
			<div class="content contentReturnReviewOpinion">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					 <el-form-item label="退回意见" prop="opinion">
						<el-input v-model="ruleForm.opinion" type="textarea" rows="3"></el-input>
					</el-form-item>
					<el-form-item class="el-form-itemBtnCenter">
						<el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
						<el-button @click="handleCloseNewReview">取消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,//弹窗是否显示
			uuid:"",//开始审查之后返回的uuid
			ruleForm:{
				opinion:"",//意见
			},
			rules:{
				opinion: [
					{ required: true, message: '请输入退回意见', trigger: 'change' }
				]
			}
		};
	},
	created(){	
	},
	methods:{
		//弹窗显示
		childFun(){
			this.dialogVisible = true; 
		},
		//弹窗关闭按钮
		handleCloseNewReview(){
			this.$refs['ruleForm'].resetFields();
			this.ruleForm.opinion="";
			this.dialogVisible = false; 

		},
		//确认
		submitForm(formName){
			this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
		}
	}
};
</script>
<style lang="scss" scope>
@import "../../../../assets/css/dialog.scss";//弹窗样式
</style>